import { render, staticRenderFns } from "./BookingServicePackagesList.vue?vue&type=template&id=522215f0"
import script from "./BookingServicePackagesList.js?vue&type=script&lang=js&external"
export * from "./BookingServicePackagesList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports